/**
 * @constant Maximum 32-bit unsigned integet value (2^32 - 1)
 */

    module.exports = 4294967295;




//////////////////
// WEBPACK FOOTER
// ./~/mout/number/MAX_UINT.js
// module id = 1624
// module chunks = 0 1 2